export default class Common {
  constructor () {
    this.mediaSwitchFlag = 'pc';
    this.breakpoint = '(max-width: 819.4px)';
  }
  init() {
    this.smoothScroll();
    const self = this;
    $(window).on('load resize', function () {
      self.mediaSwitchImg();
    });
  }
  getEnvironment () {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const appVersion = window.navigator.appVersion.toLowerCase();
    let browser;
    let device;
    let software;
    let media;
    // ブラウザ
    if (userAgent.indexOf('msie') !== -1) {
      if (appVersion.indexOf('msie 9.') !== -1) {
        browser = 'ie9';
      } else if (appVersion.indexOf('msie 10.') !== -1) {
        browser = 'ie10';
      } else {
        browser = 'ie';
      }
    } else if (userAgent.indexOf('chrome') !== -1) {
      browser = 'chrome';
    } else if (userAgent.indexOf('safari') !== -1) {
      browser = 'safari';
    } else if (userAgent.indexOf('gecko') !== -1) {
      browser = 'gecko';
    } else {
      browser = false;
    }
    // デバイス
    if (userAgent.indexOf('ipad') > 0 || (userAgent.indexOf('android') > 0 && userAgent.indexOf('mobile') < 0)) {
      device = 'tab';
    } else if (userAgent.indexOf('iphone') > 0 || userAgent.indexOf('iPod') > 0 || userAgent.indexOf('android') > 0) {
      device = 'sp';
    } else {
      device = 'pc';
    }
    // OS
    if (userAgent.indexOf('android') > 0) {
      software = 'android';
    } else if (userAgent.indexOf('iphone') > 0 || userAgent.indexOf('iPod') > 0 || userAgent.indexOf('ipad') > 0) {
      software = 'ios';
    } else if (userAgent.indexOf('windows') > 0) {
      software = 'windows';
    } else if (userAgent.indexOf('Mac') > 0) {
      software = 'mac';
    }
    // 画面幅(media)
    if (window.matchMedia(this.breakpoint).matches) {
      media = 'sp';
    } else {
      media = 'pc';
    }
    return {
      browser,
      device,
      software,
      media
    };
  }
  smoothScroll(){
    //ページ内アンカーリンク以外のリンクはis_not_anchorlinkを付与してください。
    $('a[href^="#"]').not('.is_not_anchorlink').on('click', function () {
      const href = $(this).attr('href');
      const $target = $(href === '#' || href === '' ? 'html' : href);
      const position = $target.offset().top;
      $('html, body').animate({
        scrollTop: position
      }, 300, 'swing');
      return false;
    });

    //hashがあった場合の処理
    const hash = location.hash;
    if (hash !== '' && $(hash).length) {
      const $target = $(hash);
      const position = $target.offset().top;
      $('html, body').animate({
        scrollTop: position
      }, 1, 'swing');
    }
  }
  mediaSwitchImg () {
    const self = this;
    const { media } = self.getEnvironment();
    const before = media === 'sp' ? '_pc' : '_sp';
    const after = media === 'sp' ? '_sp' : '_pc';
    let { mediaSwitchFlag } = self;
    if (mediaSwitchFlag !== media) {
      mediaSwitchFlag = media;
      $.each($('.js_media_switch_img'), function () {
        $(this).attr('src', $(this).attr('src').replace(before, after));
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/common.js